import React, {useEffect, useState} from 'react';
import {FiChevronUp} from "react-icons/fi";
import Blury from '../Blury';


const ScrollTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop || document.body.scrollTop;
            setVisible(scrolled > 300);
        };
        toggleVisible();
        window.addEventListener('scroll', toggleVisible, { passive: true });
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <button
                type="button"
                className="rn-back-top"
                onClick={scrollToTop}
                aria-label="Back to top"
                style={{display: visible ? 'inline-flex' : 'none'}}
            ><FiChevronUp /></button>
            <Blury />
        </>
    )
}

export default ScrollTop;
